"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Stepper_1 = __importDefault(require("@mui/material/Stepper"));
var StepIcon_1 = __importDefault(require("../StepIcon"));
var StepConnector_1 = __importDefault(require("../StepConnector"));
var Step_1 = __importDefault(require("@mui/material/Step"));
var styles_1 = require("./styles");
var Stepper = (0, react_1.forwardRef)(function (_a) {
    var steps = _a.steps, _b = _a.activeStep, activeStep = _b === void 0 ? 0 : _b, _c = _a.onStepClick, onStepClick = _c === void 0 ? function () { } : _c, props = __rest(_a, ["steps", "activeStep", "onStepClick"]);
    return (react_1.default.createElement(Stepper_1.default, __assign({ connector: react_1.default.createElement(StepConnector_1.default, null) }, props, { alternativeLabel: true, activeStep: activeStep, orientation: "horizontal" }), steps.map(function (step, idx) {
        return (react_1.default.createElement(Step_1.default, { key: step.label, "aria-label": "".concat(step.label, " ").concat(idx === activeStep ? ' current step' : ' step').concat(idx + 1, " of ").concat(steps.length), tabIndex: idx <= activeStep ? 0 : -1, role: idx === activeStep ? 'none' : 'button', onKeyDown: function (event) {
                if (event.key === 'Enter') {
                    onStepClick(step, idx);
                }
            } },
            react_1.default.createElement(styles_1.StyledStepLabel, { StepIconComponent: StepIcon_1.default, onClick: function () {
                    if (idx < activeStep) {
                        onStepClick(step, idx);
                    }
                } },
                react_1.default.createElement("span", { className: "label" }, step.label))));
    })));
});
exports.default = Stepper;
//# sourceMappingURL=index.js.map